// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Dashboard readability — base scale aligned with frontend/ (~15px body).
 */

.page-content {
  font-size: 15px;
  line-height: 1.55;
}

html {
  font-size: 16px;
}

.app-footer {
  font-size: 14px;
}

.license-hub-tab {
  font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/DashboardTypography.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/**\n * Dashboard readability — base scale aligned with frontend/ (~15px body).\n */\n\n.page-content {\n  font-size: 15px;\n  line-height: 1.55;\n}\n\nhtml {\n  font-size: 16px;\n}\n\n.app-footer {\n  font-size: 14px;\n}\n\n.license-hub-tab {\n  font-size: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
